import { useEffect, useState } from "react";
import Button from "../../../components/button/Button";
import { BUTTON_TYPE } from "../../../components/button/constants";
import FileUpload from "../../../components/fileupload/FileUpload";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import { useDispatch, useSelector } from "react-redux";
import { componentKey, setShowAddAttachmentPopup, setUploadedFile } from "./FormAttachmentUploadSlice";
import { saveAttachment } from "./FormAttachmentUploadSaga";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks";
import Popup from "../../../components/popup/Popup";
import styles from './FormAttachmentUpload.styles';

export default function FormAttachmentUpload({ addAttachmentBtnLabel = "Add Attachment", onChangeCb = () => { }, value = "", name = "", allowedFileTypes = ['.pdf', '.doc', '.docx', '.png', '.jpeg'], disabled, showRemoveBtn = true, saveAttachmentBase = "BOI" }) {
    useGarbageCollector(componentKey);
    const { showAddAttachmentPopup, uploadedFile, uploadedFileData } = useSelector(state => state[componentKey]);

    const dispatch = useDispatch();

    useEffect(() => {
        if (uploadedFileData?.FilePath && uploadedFileData?.source === name) {
            onChangeCb(uploadedFileData);
        }
    }, [uploadedFileData])

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];

        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            dispatch(setUploadedFile(file));

        } else {
            dispatch(addNotifications({
                heading: "File format not supported",
                message: `Invalid file format. Please upload a ${allowedFileTypes.join(", ")} file.`
            }));
        }
    };

    const handleUploadedFileChange = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (allowedFileTypes.includes(`.${fileExtension}`)) {
            if (file) {
                dispatch(setUploadedFile(file));
            }
        } else {
            dispatch(addNotifications({ heading: "File format not supported", message: "Invalid file format. Please upload a .xlsx or .csv file." }));
        }
        event.target.value = null;
    };

    const handleSaveAttachment = () => {
        if (uploadedFile) {
            dispatch(saveAttachment({ uploadedFile: uploadedFile, source: name, commonBase: saveAttachmentBase }))
        } else {
            dispatch(addNotifications({ heading: "Missing attachment", message: "Please add attachment", variant: TOASTER_VARIANT.WARNING }))
        }
    }

    const handleCancelAttachment = () => {
        dispatch(setUploadedFile(null));
        dispatch(setShowAddAttachmentPopup(false))
    }

    const handleRemove = () => {
        onChangeCb("");
    }

    return <>
        <div>
            {
                showRemoveBtn && value?.filePath ? <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                    <p key={name} style={{ marginRight: '10px', marginBottom: "0px" }}>Uploaded File: {value?.fileName}</p>
                    {
                        !disabled && <>
                            <button onClick={handleRemove} style={{ cursor: 'pointer', background: 'transparent', border: 'none', padding: '0', margin: '0' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                    <path d="M13.354 3.354a.5.5 0 0 0-.708-.708L8 7.293 3.354 2.646a.5.5 0 1 0-.708.708L7.293 8l-4.647 4.646a.5.5 0 0 0 .708.708L8 8.707l4.646 4.647a.5.5 0 0 0 .708-.708L8.707 8l4.647-4.646z" />
                                </svg>
                            </button>
                        </>
                    }

                </div>
                    :
                    <Button disabled={disabled} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => { dispatch(setShowAddAttachmentPopup(name)) }}>{addAttachmentBtnLabel}</Button>
            }
            {
                (showAddAttachmentPopup === name) && <Popup title={addAttachmentBtnLabel} onCloseCb={() => handleCancelAttachment()} isPopupOpen={showAddAttachmentPopup === name} customPopupSyles={styles.popupCustomStyle} childrenStyles={styles.popupChildrenStyles}>
                    <FileUpload
                        title="Upload file"
                        uploadedFile={uploadedFile}
                        onDropCb={handleDrop}
                        allowedFileType={allowedFileTypes}
                        onInputChangeCb={handleUploadedFileChange}
                        containerBodyCustomStyles={styles.uploadContainerBodyCustomStyles}
                    />
                    <div style={styles.popupFooterButton}>
                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => handleSaveAttachment()}>Save</Button>
                        <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => handleCancelAttachment()}>Cancel</Button>
                    </div>
                </Popup>
            }

        </div>
    </>
}